<template lang="pug">
login-form.login.line-height-none(
  ref='template',
  :userRole='userRole',
  :loginButtonEvent='loginButtonEvent',
  :errorMessages='errorMessages'
)
  template(#loginTitle) システム管理者ログイン
  template(#accountCodeLabel) ID
  template(#passwordLabel) PW
  template(#loginButtonLabel) ログイン
</template>

<script lang="ts">
import { Component, Mixins, Ref } from 'vue-property-decorator'
import LoginMethods from '@/mixins/LoginMethods'
import LoginForm from '@/components/templates/manager/LoginForm.vue'
import { UserRoles } from '@/const/UserRoles'

/**
 * システム管理者・ログイン画面
 */
@Component({
  components: {
    LoginForm,
  },
})
export default class DebugHome extends Mixins(LoginMethods) {
  // テンプレートRef
  @Ref() template!: LoginForm

  // システム管理者権限
  private userRole: UserRoles = UserRoles.ADMIN

  // ログイン処理
  private async loginButtonEvent() {
    this.$loading.start()
    await this.adminLogin(this.template.accountCode, this.template.password)
    this.$loading.complete()
  }

  /**
   * ログイン後の遷移先ページをオーバーライド
   */
  public topPagePath(): string {
    return '/admin/academy-management'
  }
}
</script>
